<template>
  <div class="preview-form">
    <i-button @click="print=true">打印</i-button>
    <div class="padding-top-20"></div>
    <div class="print-area">
      <v-print :doPrint.sync="print">
        <h1 class="text-center">工程保证人备案通知书</h1>
        <div class="padding-top-20"></div>
        <table class="preview-table">
          <tbody>
            <tr>
              <td class="title" colspan="2"><span>公 司 名 称</span></td>
              <td colspan="3">{{guarantorModel.name}}</td>
            </tr>
            <tr>
              <td class="title" colspan="2"><span>注册地址</span></td>
              <td colspan="3">{{guarantorModel.address}}</td>
            </tr>
            <tr v-if="guarantorModel.type===1">
              <td class="title" colspan="2"><span>经营范围</span></td>
              <td colspan="3">{{guarantorModel.scope}}</td>
            </tr>
            <tr v-if="guarantorModel.type===1">
              <td class="title" colspan="2"><span>社会信用代码</span></td>
              <td>{{guarantorModel.businessLicense}}</td>
              <td class="title"><span>成立日期</span></td>
              <td>{{guarantorModel.estDate?require('moment')(guarantorModel.estDate).format('YYYY-MM-DD'):null}}</td>
            </tr>
            <tr>
              <td class="title" colspan="2"><span>注册资本</span></td>
              <td colspan="3">{{$common.transformNumberIntoCHS(guarantorModel.capital*10000)}}</td>
            </tr>
            <tr v-if="guarantorModel.type===1">
              <td class="title" colspan="2"><span>注册类型</span></td>
              <td>{{guarantorModel.corpType}}</td>
              <td class="title"><span>核准日期</span></td>
              <td>{{guarantorModel.estDate?require('moment')(guarantorModel.auditTime).format('YYYY-MM-DD'):null}}</td>
            </tr>
            <tr v-if="guarantorModel.type===1">
              <td class="title" colspan="2"><span>营业期限</span></td>
              <td>{{guarantorModel.businessTerm}}</td>
              <td class="title"><span>申请日期</span></td>
              <td>{{guarantorModel.estDate?require('moment')(guarantorModel.createTime).format('YYYY-MM-DD'):null}}</td>
            </tr>
            <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
              <td class="title" colspan="2"><span>偿付充足率信息</span></td>
              <td>{{guarantorModel.solvency}}</td>
              <td class="title"><span>保证业务总量</span></td>
              <td>{{guarantorModel.totalGuaAmount}}万元</td>
            </tr>
            <tr>
              <td class="title" colspan="2"><span>法定代表人</span></td>
              <td :colspan="[2,3,10].indexOf(guarantorModel.type)>-1?'1':'3'">{{guarantorModel.legalPersonName}}</td>
              <td class="title"><span>电话</span></td>
              <td>{{guarantorModel.legalPersonTel}}</td>
            </tr>
            <tr v-if="guarantorModel.type===1">
              <td class="title" colspan="2"><span>总经理</span></td>
              <td colspan="3">{{guarantorModel.generalManagerName}}</td>
            </tr>
            <tr>
              <td class="title" colspan="2"><span>联系人</span></td>
              <td>{{guarantorModel.contact}}</td>
              <td class="title"><span>公司电话</span></td>
              <td>{{guarantorModel.contactTel}}</td>
            </tr>
            <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
              <td class="title" colspan="2"><span>管理人员</span></td>
              <td>{{guarantorModel.supervisorContactPerson}}</td>
              <td class="title"><span>电话</span></td>
              <td>{{guarantorModel.supervisorContactTel}}</td>
            </tr>
            <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
              <td class="title" colspan="2"><span>管理机构</span></td>
              <td>{{guarantorModel.supervisorName}}</td>
              <td class="title"><span>电话</span></td>
              <td>{{guarantorModel.supervisorTel}}</td>
            </tr>
            <tr v-if="guarantorModel.type===1">
              <td rowspan="3" class="bold"><b>从<br>业<br>人<br>员</b></td>
              <td><b>工程建设类专业技术人员</b></td>
              <td>{{guarantorModel.qualifiedTotal}}</td>
              <td colspan="2" rowspan="3">
                <p><b>单位盖章</b></p>
                <div class="padding-top-20"></div>
                <p><b>法定代表人签字</b></p>
              </td>
            </tr>
            <tr v-if="guarantorModel.type===1">
              <td><b>财务人员</b></td>
              <td>{{guarantorModel.cpaTotal}}</td>
            </tr>
            <tr v-if="guarantorModel.type===1">
              <td><b>法务工作人员</b></td>
              <td>{{guarantorModel.solicitorTotal}}</td>
            </tr>
            <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
              <td colspan="5">
                <div class="padding-top-20"></div>
                <div class="padding-top-20"></div>
                <p><b>单位公章</b></p>
                <div class="padding-top-20"></div>
                <div class="padding-top-20"></div>
                <p><b>法定代表人签字</b></p>
                <div class="padding-top-10"></div>
                <p><b>申请日期：</b></p>
              </td>
            </tr>
          </tbody>
        </table>
      </v-print>
    </div>
    <div id="print"></div>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
import vPrint from 'syl-vue-printer'
export default {
  name: 'preview-form',
  props: {
  },
  components: {
    vPrint
  },
  data () {
    return {
      loading: false,
      guarantorStatus: null,
      guarantorModel: {
        id: null,
        name: null,
        businessLicense: null,
        legalPersonName: null,
        contact: null,
        contactTel: null,
        regCity: null,
        address: null,
        email: null,
        postCode: null,
        capital: null,
        estDate: null,
        scope: null,
        homePage: null,
        fax: null,
        legalPersonID: null,
        legalPersonIDImgs: [],
        legalPersonRole: null,
        legalPersonTitle: null,
        legalPersonTel: null,
        generalManagerName: null,
        generalManagerRole: null,
        generalManagerTitle: null,
        supervisorName: null,
        supervisorTel: null,
        supervisorContactPerson: null,
        supervisorContactTel: null,
        solvency: null,
        totalGuaAmount: null,
        employeeTotal: 0,
        titledTotal: 0,
        titledMedTotal: 0,
        titledSeniorTotal: 0,
        qualifiedTotal: 0,
        regSupervTotal: 0,
        regConstrTotal: 0,
        regCostTotal: 0,
        prjManagerTotal: 0,
        cpaTotal: 0,
        solicitorTotal: 0,
        introduction: null,
        guarRange: null,
        orgChartPath: '',
      },
      print: false
    }
  },
  watch: {
  },
  computed: {
  },
  mounted () {
    this.getGuarantorDetail()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getGuarantorDetail () {
      Api.Guarantor.getMyGuarantorDetail().then((res) => {
        Object.assign(this.guarantorModel, res)
        this.guarantorStatus = this.guarantorModel.status
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
        if (err.message.indexOf('该用户未绑定承保人') > -1) {
          this.guarantorStatus = 0
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.preview-table {
  border: 2px solid #000;
  border-spacing: 0;
  border-collapse: collapse;
  width: 756px;
  margin: 0 auto;
  td {
    font-size: 16px;
    padding: 10px 8px;
    border: 1px solid #000;
    &:not(.title) {
    }
    &.title {
      width: 160px !important;
      font-weight: bold;
      span {
        max-width: 144px;
        display: inline-block;
        text-align: justify;
        width: 100%;
        text-align-last: justify;
      }
    }
  }
}
</style>
